import { jsx as _jsx } from "react/jsx-runtime";
import { useNavigate } from "react-router-dom";
import { useRetrievePlayerByExternalUserId, useRetrieveTeamsByPlayerId, useUpdateExternalUser, } from "../ApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import { useNumericParams } from "../utils/useNumericParams";
import { OfflinePlayerForm } from "./OfflinePlayerForm";
var playerToMetadata = function (player) {
    var _a, _b;
    return ({
        nationality: (_a = player.nationality) !== null && _a !== void 0 ? _a : "US",
        foot: player.foot || "Right",
        positionOne: (_b = player.positionOne) !== null && _b !== void 0 ? _b : "GK",
        positionTwo: player.positionTwo,
        bio: player.bio,
        heading: player.heading,
        passing: player.passing,
        positioning: player.positioning,
        defending: player.defending,
        finishing: player.finishing,
        dribbling: player.dribbling,
        shooting: player.shooting,
        tackling: player.tackling,
        crossing: player.crossing,
        leadership: player.leadership,
        communication: player.communication,
        speed: player.speed,
        fitness: player.fitness,
        keeping: player.keeping,
    });
};
export var UpdateExternalUser = function () {
    var id = useNumericParams().id;
    var navigate = useNavigate();
    var _a = useRetrievePlayerByExternalUserId({ externalUserId: id }), player = _a.data, isLoading = _a.isLoading, error = _a.error;
    var _b = useRetrieveTeamsByPlayerId({ playerId: player === null || player === void 0 ? void 0 : player.id }), teams = _b.data, isTeamsLoading = _b.isLoading, teamsError = _b.error;
    var updateExternalUserMutation = useUpdateExternalUser({
        player: player,
        playerTeams: teams,
        onMutate: function () { },
        onSuccess: function () {
            navigate("/players/".concat(player.id, "/"));
        },
        onError: function () { },
    });
    if (isLoading || updateExternalUserMutation.isLoading || isTeamsLoading) {
        return _jsx(Loading, {});
    }
    if (error || teamsError || !player || !player.externalUser || !teams) {
        return _jsx(ErrorView, { error: error });
    }
    return (_jsx(OfflinePlayerForm, { title: "Edit Player", submitLabel: "Save", defaultValues: {
            externalUser: {
                firstName: player.externalUser.firstName,
                lastName: player.externalUser.lastName,
            },
            player: playerToMetadata(player),
        }, isError: !!updateExternalUserMutation.isError, errorMessage: "Failed to update player!", onSubmit: function (data) {
            return updateExternalUserMutation.mutate(data);
        }, onCancel: function () { return navigate(-1); } }));
};
